import React from "react";
import ReactEcharts from "echarts-for-react";
import { formatShelfAppearance } from "../utils";
import { filter, map, values } from "lodash-es";
import { generateDataPoint } from "../utils";
import {
  BRAND_GRAY_LIGHT,
  FOREST_GREEN_DARK,
  FOREST_GREEN_LIGHT,
  BRAND_PURPLE_MEDIUM,
  BRAND_PURPLE_LIGHT,
  MINT_GREEN_LIGHT,
  MINT_GREEN_MEDIUM,
  TEXT_GRAY,
} from "../theme/colors";
import { useTranslation } from "react-i18next";
const ShelfAppearanceChart = ({ data }) => {
  const { t } = useTranslation();
  const appereance_keys = [
    "asExpected",
    "didNotExist",
    "notRefilled",
    "messy",
    "campaignMissing",
    "limited_visibility",
    "wrong_campaign",
  ];
  const data_values = appereance_keys.map((key) =>
    t(`shelf_appearance.${key}`)
  );
  const plotData = map(appereance_keys, (key) =>
    generateDataPoint(data, "shelfAppearance", key, (key) =>
      t(`shelf_appearance.${key}`)
    )
  );
  const vals = data.map((item) => item.shelfAppearance);
  let unique = [...new Set(vals)];
  console.log(unique);
  const getOption = () => {
    return {
      toolbox: {
        show: false,
      },
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b}: {c} ({d}%)",
      },
      legend: {
        orient: "vertical",
        icon: "roundRect",
        itemWidth: 13,
        itemHeight: 13,
        x: "right",
        data: data_values,
        textStyle: {
          color: [TEXT_GRAY],
        },
      },
      color: [
        FOREST_GREEN_DARK,
        MINT_GREEN_LIGHT,
        BRAND_PURPLE_MEDIUM,
        BRAND_GRAY_LIGHT,
        FOREST_GREEN_LIGHT,
        BRAND_PURPLE_LIGHT,
        MINT_GREEN_MEDIUM,
      ],

      series: [
        {
          name: t("dashboard.shelf_appearance_alternative"),
          type: "pie",
          radius: ["45%", "55%"],
          center: ["50%", "65%"],

          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: "center",
            },
            emphasis: {
              show: true,
              textStyle: {
                fontSize: "18",
                fontWeight: "bold",
              },
            },
          },
          labelLine: {
            normal: {
              show: false,
            },
          },
          data: plotData,
        },
      ],
    };
  };
  return (
    <React.Fragment>
      {/* {plotData.map((item) => item.value).filter((value) => value !== 0)
        .length > 0 ? ( */}
      <ReactEcharts style={{ height: "350px" }} option={getOption()} />
      {/* ) : (
        <Typography>Ingen data att visas än</Typography>
      )} */}
    </React.Fragment>
  );
};
export default ShelfAppearanceChart;
